import { GetAgentStatusResponse } from './types';

// Shared mock used by RewardsTab and TwentySixForTwentySix when
// REWARDS_MOCK_ENABLED is set. Not imported in production paths.
// progress values are internally consistent with MOCK_REWARDS_CONFIG's
// entry_threshold of 5: 3 binds + 2 remaining = 5-per-entry cycle.
export const MOCK_AGENT_STATUS: GetAgentStatusResponse = {
  availableEntries: 5,
  hasActiveAttempt: false,
  activeAttemptId: null,
  lastResult: null,
  progress: { qualifyingBindsCurrentPhase: 3, policiesUntilNextEntry: 2 },
  phase: {
    number: 2,
    code: 'ACT2',
    name: 'Act 2',
    start: '2026-07-08T00:00:00Z',
    end: '2026-09-30T23:59:59Z',
    attemptType: 'SPIN',
  },
  balance: { regular: 2, bonus: 3, bonusExpiresAt: '2026-09-30T23:59:59Z' },
};

// ACT3 variant — set REWARDS_MOCK_ACT3=1 (window.env) or env.rewardsMockAct3 to use instead of MOCK_AGENT_STATUS.
// Preserves the shipped raffle (ACT2) dev experience as the default.
// hasActiveAttempt + lastResult seed the reconnect-hydration path in useScratchOff so the
// scratch screen is reachable in mock mode without a pendingAttempt from context.
// lastResult uses the ACT3 SMALL outcome (prizeAmount 100) from MOCK_REWARDS_CONFIG ACT3 phase
// so outcomesForPhase(...).findIndex resolves a matching outcomeConfig.
export const MOCK_AGENT_STATUS_ACT3: GetAgentStatusResponse = {
  ...MOCK_AGENT_STATUS,
  hasActiveAttempt: true,
  activeAttemptId: 'mock-scratch-act3-001',
  lastResult: {
    attemptType: 'SCRATCH_OFF',
    outcome: 'SMALL',
    prizeCode: 'SMALL',
    prizeAmount: 100,
    resolvedAt: '2026-10-01T12:00:00Z',
  },
  phase: {
    number: 3,
    code: 'ACT3',
    name: 'Act 3',
    start: '2026-10-01T00:00:00Z',
    end: '2026-12-31T23:59:59Z',
    attemptType: 'SCRATCH_OFF',
  },
};
